<template>
  <div>
    <!--기본정보-->
    <field-select-module v-if="hostname == 'ep.maot.co.kr'" v-model="form.stdInfo" :board="this.board" :is-print="isPrint" field-name="사업장명" />
    <field-select-module v-else v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 사업장 세부 정보 / 사업개요 -->
    <!--    은평전용-->
    <div v-if="hostname == 'ep.maot.co.kr'" class="mt-5">
      <field-info title="사업장 세부 정보" :fieldId="form.stdInfo.field_id" />
    </div>
    <!--    은평 외-->
    <div v-else class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 사업개요</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">사업장명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputB_1" class="w-full flex-1"/>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">사업금액</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputB_2" class="w-full flex-1"/>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">구분</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
          <vs-select v-else class="w-full flex-1" autocomplete v-model="form.inputB_3" @change="onChangeCat1">
            <vs-select-item v-for="option in cat1List" :key="option.cat1" :text="option.cat1" :value="option.cat1" />
          </vs-select>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">종류</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <vs-select v-else class="w-full flex-1" autocomplete v-model="form.inputB_4" @change="onChangeCat2">
            <vs-select-item v-for="option in cat2List" :key="option.cat2" :text="option.cat2" :value="option.cat2" />
          </vs-select>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">세분류</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
          <vs-select v-else class="w-full flex-1" autocomplete v-model="form.inputB_5" @change="onChangeCat3">
            <vs-select-item v-for="option in cat3List" :key="option.cat3" :text="option.cat3" :value="option.cat3" />
          </vs-select>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">주소</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_6 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputB_6" class="w-full flex-1"/>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">공사기간</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_7 }} ~ {{ form.inputB_8 }}</p>
          <div v-else class="flex-1 flex items-center">
            <date-selector class="w-full flex-1" v-model="form.inputB_7" :readonly="board.readonly" />
            <p class="px-2">~</p>
            <date-selector class="w-full flex-1" v-model="form.inputB_8" :readonly="board.readonly" />
          </div>
        </div>
      </div>
    </div>

    <!-- 발주자 정보 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 발주자 정보</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">회사명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_1 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputC_1" class="w-full flex-1"/>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">대표자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_2 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputC_2" class="w-full flex-1"/>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">주소</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_3 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputC_3" class="w-full flex-1"/>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">전화번호</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_4 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputC_4" class="w-full flex-1"/>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">지정된 담당자</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_5 }} </span>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputC_5" class="w-full flex-1"/>
        </div>
      </div>
    </div>

    <!-- 관련내용 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 관련내용</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-12 flex items-start">
          <div class="label-text mr-4 mt-2">내용</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputD_1 }} </span>
          <ml-textarea
            v-else
            class="flex-1 w-full"
            rows="5"
            v-model="form.inputG_1"
            :readonly="board.readonly"
            placeholder="□ 공사개요
□ 특수 구조물 개요
□ 주요 공법
2. 설계안전보건대장의 안전·보건조치 이행계획
3. 유해·위험방지계획서 심사 및 확인결과에 대한 조치내용(해당 시 작성)
4. 산업안전보건관리비 변경내역
5. 건설공사 산업재해예방 지도 계약여부, 지도결과 및 조치내용(해당 시 작성)
6. 작성(변경) 일자
7. 작성 및 확인자 등은 관련서식 작성 후 아래와 같이 파일첨부"
          />
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :readonly="board.readonly" :is-print="isPrint"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelector from "@/components/selector/DateSelector";
import BusinessInfo from "@/components/BusinessInfo";
import config from "../../../../../public/config";

import FieldInfo from "@/components/FieldInfo.vue";

export default {
  components: {
    BusinessInfo,
    DateSelector,
    FieldSelectModule,
    FileUploadModule,
    FieldInfo,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  async mounted() {
    await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", {});
    this.cat1List = this.$store.state.project.fieldFacilityCategoryOptions;
  },
  data() {
    return {
      form: {
        stdInfo: {},
        businessInfo: {},

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",
        inputC_5: "",

        inputD_1: "",

        fileList: [],
      },
      cat1List: [],
      cat2List: [],
      cat3List: [],
      hostname: config.HOST_NAME,
    };
  },
  methods: {
    updateBusiness(value) {
      this.form.businessInfo = value;
    },
    async onChangeCat1(data) {
      if (data) {
        await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", { cat1: data });
        this.cat2List = this.$store.state.project.fieldFacilityCategoryOptions;
      }
    },
    async onChangeCat2(data) {
      if (data) {
        await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", { cat1: this.form.inputB_3, cat2: data });
        this.cat3List = this.$store.state.project.fieldFacilityCategoryOptions;
      }
    },
    async onChangeCat3(data) {
      if (data) {
        await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", { cat1: this.form.inputB_3, cat2: this.form.inputB_4, cat3: data });
        this.cat4List = this.$store.state.project.fieldFacilityCategoryOptions;
      }
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 16px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
